import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import resolveUrl from '../../../utils/urls/resolve-url';
import * as b from "../../bootstrap.module.css";
import Icon from "../../icon.tsx";

const CarLoanContents = ({ active }) => {
  const { ranking, calculator, promotion, articles } = useStaticQuery(graphql`
    query CarLoanContents {
      ranking: mysqlRanking(mysqlId: {eq: 123}) {
        url
        prefix_url
      }

      calculator: mysqlTerms(mysqlId: {eq: 254}) {
        term_normalized
        path
        menu_icon
      }

      promotion: mysqlTerms(mysqlId: {eq: 252}) {
        term_normalized
        path
      }

      articles: allMysqlBlog(
        filter: {blogTerms: {elemMatch: {term: {eq: "menu-kredyty-samochodowy"}}}},
        limit: 4
      ) {
        nodes {
          title
          terms_path
          term_normalized
          url
          thumbnail_canvas
        }
      }
    }
  `);

  return (<>
    {ranking && (<>
      <strong>Rankingi</strong>

      <Link 
        to={resolveUrl(ranking.prefix_url, ranking.url)} 
        className={["top-navigation-link", "gold", b.mt2, b.mb4].join(' ')}
      >
        {active && <span className="top-navigation-link-icon">
          <Icon icon="Ranking" size={34} />
        </span>}

        Ranking kredytów&nbsp;samochodowych
      </Link>
    </>)}

    {calculator && (<>
      <strong>Kalkulatory</strong>

      <Link
        to={resolveUrl(calculator.path, calculator.term_normalized)} 
        className={["top-navigation-link", b.mt2, b.mb4].join(' ')}
      >
       {active && <span className="top-navigation-link-icon">
          <Icon icon={calculator.menu_icon} size={34} />
        </span>}

        Kalkulator kredytu&nbsp;samochodowego
      </Link>
    </>)}

    {promotion && (<>
      <strong>Promocje</strong>

      <Link
        to={resolveUrl(promotion.path, promotion.term_normalized)} 
        className={["top-navigation-link", b.mt2, b.mb4].join(' ')}
      >
        {active && <span className="top-navigation-link-icon">
          <Icon icon="Coins" size={34} />
        </span>}

        Promocje kredytów&nbsp;samochodowych
      </Link>
    </>)}

    {active && articles.nodes.length > 0 && (<>
      <strong>Artykuły o kredytach samochodowych</strong>

      <div className={['top-navigation-posts', b.mt2, b.pt1].join(' ')}>
        {articles.nodes.map((article, i) => (
          <Link key={i} to={resolveUrl(article.terms_path, article.term_normalized, article.url)}>
            <img src={article.thumbnail_canvas?.replace('/fa/', '/fk/')} className="top-navigation-thumbnail" loading="lazy" alt="" />
            
            <strong>{article.title}</strong>
          </Link>
        ))}
      </div> 
    </>)} 
  </>);
};

export default CarLoanContents;
